import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'dateTimezone',
  pure: true,
  standalone: true
})
export class DateTimezonePipe implements PipeTransform {
  transform(value: string | number | Date): string {
    if (!value) return '';

    const date = value instanceof Date ? value : new Date(value);

    return new Intl.DateTimeFormat('en-US', {
      year: 'numeric',
      month: 'numeric',
      day: 'numeric',
      hour: 'numeric',
      minute: '2-digit',
      timeZoneName: 'short'
    }).format(date);
  }
}
